/** 特效来源 */
export var MATERIAL_EFFECT_SOURCE = {
  HEYCAN: 1,
  LOKI: 2,
  MUSIC_LIBRARY: 3
};

/** 正常是 100 - 均通过 */
export var REVIEW_STATUS = {
  unknown: 0,
  preAudit: 1,
  inSafeAudit: 2,
  securityReviewing: 2,
  inQualityAudit: 3,
  qualityReviewing: 3,
  safeAuditNoPass: 4,
  securityReviewFailed: 4,
  qualityAuditNoPass: 5,
  qualityReviewFailed: 5,
  copyrightReviewing: 6,
  copyrightReviewFailed: 7,
  similarReviewFailed: 8,
  allPass: 100
};

/** 正常是 102 - 上线 */
export var MATERIAL_STATUS = {
  deleted: 22,
  offline: 23,
  banned: 25,
  online: 102,
  selfOnly: 103,
  preAudit: 141,
  selfView: 144
};
export var EmoticonType = {
  Static: 0,
  Dynamic: 1
};